var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('list',{ref:"list"},[_c('template',{slot:"toolbar-right"},[_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.onCustomTable}},[_vm._v("动态明细列")]),_c('el-button',{attrs:{"type":"success","plain":""},on:{"click":_vm.onExport}},[_vm._v("导出")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }